module.exports = __webpack_public_path__ + "static/media/Pollen.93a83745.m4a";